import {
  ODataHeader,
  ODataString,
  ODataEnum,
  ODataDateTime,
  ODataDecimal
} from "pbas-vue-components";
import { i18n } from "@/plugins/i18n";
const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});
import { translate2 } from '../trans2'

function getHeaders(invoiceCategories) {
  const headers = [
    new ODataHeader({
      title: "Id",
      type: new ODataString("Id"),
      sortable: true,
      visible: false,
      searchable: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      title: "headers.invoices.invoice_number",
      type: new ODataString("InvoiceNumber"),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.invoices.invoice_category",
      type: new ODataEnum("InvoiceCategory", {
        getString: (item) => {
          return i18n.t("enums." + item.InvoiceCategory);
        },
        dropdownItems: invoiceCategories,
      }),

      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      type: new ODataString("BillingTerm/FullName"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      type: new ODataString("BillingTerm/Translations[]/LanguageCode"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      title: "components.invoices.new_invoice_dialog.billing_period",
      type: new ODataString("BillingTerm/Translations[]/FullName", {
        getString: (item) => {
          // console.log(item);
          return translate2(item.BillingTerm, "FullName");}
      }),
      sortable: true,
      visible: true,
      searchable: true,
      orderByKey: "Name"
    }),
    new ODataHeader({
      title: "headers.hourshistory.total_amount",
      type: new ODataDecimal("TotalAmount", {
        getString: (item) => {
          const value = item.TotalAmount;
          if (value === null || value === undefined) {
            return "";
          }
          if (typeof value !== "number") {
            return value;
          }
          return formatter.format(value);
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.claims_payments.IssuedAt",
      type: new ODataDateTime("IssuedAt"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.claims_payments.IssuedBy",
      type: new ODataString("IssuedBy"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
  ];
  return headers;
}
export default getHeaders;
